"use client";

import type { PageContext } from "~lib/storyblok";

import type { ReactNode } from "react";
import { DesktopNav } from "./desktop-nav";
import { MobileNav } from "./mobile-nav";
import type { HeaderBlok, HeaderNavValues } from "./types";

type HeaderProps = {
  blok: HeaderBlok | undefined;
  initialValue?: HeaderNavValues; // Demo prop for storybook demo purposes
  customBanner?: ReactNode;
} & PageContext;

export function Header({
  blok,
  initialValue,
  customBanner,
  ...context
}: HeaderProps) {
  if (!blok) return null;

  return (
    <>
      <MobileNav
        customBanner={customBanner}
        initialValue={initialValue}
        blok={blok}
        {...context}
      />

      <DesktopNav
        customBanner={customBanner}
        initialValue={initialValue}
        blok={blok}
        {...context}
      />
    </>
  );
}
